
// Vue
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";

// Types
import { DomainGroup } from "@/store/user-management/types";

// Namespaces
const UserManagement = namespace("userManagement");

@Component({
})

export default class DomainGroupMappingModal extends Vue {
	// Props
	@Prop({ default: null, type: Object }) selectedDomainGroup: DomainGroup;
	@Prop({ default: false, type: Boolean }) visible: boolean;

	// Actions
	@UserManagement.Action deleteDomainGroup: (domainGroup: DomainGroup) => Promise<void>;

	@Emit("toggle-modal")
	private closeModal(): void {}

	private async removeDomainGroup(): Promise<void> {
		await this.deleteDomainGroup(this.selectedDomainGroup);
		this.closeModal();
	}
}
